<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import { handleSubmit, parseFormdata, updateNextRoute } from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute;
	updateNextRoute();
	redirectRoute = localStorage.getItem("nextRoute");
	const form = useForm();

	const handleClick = () => {
		handleSubmit($api_writeForm, parseFormdata($form), redirectRoute);
	};

	let monkeypoxfields = [
		// monkeypoximportance
		{
			labelName: "monkeypox-importance",
			label: "How <strong>important</strong> do you think <strong>Monkeypox</strong> (and surrounding issues) is?",
			options: [
				{
					type: "radio",
					value: "1_no-importance", // value/response to send to server
					option: "No importance", // what to display
				},
				{
					type: "radio",
					value: "2_very-low-importance",
					option: "Very low importance",
				},
				{
					type: "radio",
					value: "3_low-importance",
					option: "Low importance",
				},
				{
					type: "radio",
					value: "4_some-importance",
					option: "Some importance",
				},
				{
					type: "radio",
					value: "5_high-importance",
					option: "High importance",
				},
				{
					type: "radio",
					value: "6_very-high-importance",
					option: "Very high importance",
				},
			],
		},
		// monkeypoxnewsworthiness
		{
			labelName: "monkeypox-newsworthiness",
			label: "How <strong>newsworthy</strong> do you think <strong>Monkeypox</strong> (and surrounding issues) is?",
			options: [
				{
					type: "radio",
					value: "1_no-newsworthiness", // value/response to send to server
					option: "No newsworthiness", // what to display
				},
				{
					type: "radio",
					value: "2_very-low-newsworthiness",
					option: "Very low newsworthiness",
				},
				{
					type: "radio",
					value: "3_low-newsworthiness",
					option: "Low newsworthiness",
				},
				{
					type: "radio",
					value: "4_some-newsworthiness",
					option: "Some newsworthiness",
				},
				{
					type: "radio",
					value: "5_high-newsworthiness",
					option: "High newsworthiness",
				},
				{
					type: "radio",
					value: "6_very-high-newsworthiness",
					option: "Very high newsworthiness",
				},
			],
		},
	];

	let johnnyfields = [
		// johnnyimportance
		{
			labelName: "johnny-importance",
			label: "How <strong>important</strong> do you think the <strong>Johnny Depp-Amber Heard Defamation Trial</strong> (and surrounding issues) is?",
			options: [
				{
					type: "radio",
					value: "1_no-importance", // value/response to send to server
					option: "No importance", // what to display
				},
				{
					type: "radio",
					value: "2_very-low-importance",
					option: "Very low importance",
				},
				{
					type: "radio",
					value: "3_low-importance",
					option: "Low importance",
				},
				{
					type: "radio",
					value: "4_some-importance",
					option: "Some importance",
				},
				{
					type: "radio",
					value: "5_high-importance",
					option: "High importance",
				},
				{
					type: "radio",
					value: "6_very-high-importance",
					option: "Very high importance",
				},
			],
		},
		// johnnynewsworthiness
		{
			labelName: "johnny-newsworthiness",
			label: "How <strong>newsworthy</strong> do you think the <strong>Johnny Depp-Amber Heard Defamation Trial</strong> (and surrounding issues) is?",
			options: [
				{
					type: "radio",
					value: "1_no-newsworthiness", // value/response to send to server
					option: "No newsworthiness", // what to display
				},
				{
					type: "radio",
					value: "2_very-low-newsworthiness",
					option: "Very low newsworthiness",
				},
				{
					type: "radio",
					value: "3_low-newsworthiness",
					option: "Low newsworthiness",
				},
				{
					type: "radio",
					value: "4_some-newsworthiness",
					option: "Some newsworthiness",
				},
				{
					type: "radio",
					value: "5_high-newsworthiness",
					option: "High newsworthiness",
				},
				{
					type: "radio",
					value: "6_very-high-newsworthiness",
					option: "Very high newsworthiness",
				},
			],
		},
	];

	let electionfields = [
		// electionimportance
		{
			labelName: "election-importance",
			label: "How <strong>important</strong> do you think the <strong>U.S. Midterm Elections</strong> (and surrounding issues) are?",
			options: [
				{
					type: "radio",
					value: "1_no-importance", // value/response to send to server
					option: "No importance", // what to display
				},
				{
					type: "radio",
					value: "2_very-low-importance",
					option: "Very low importance",
				},
				{
					type: "radio",
					value: "3_low-importance",
					option: "Low importance",
				},
				{
					type: "radio",
					value: "4_some-importance",
					option: "Some importance",
				},
				{
					type: "radio",
					value: "5_high-importance",
					option: "High importance",
				},
				{
					type: "radio",
					value: "6_very-high-importance",
					option: "Very high importance",
				},
			],
		},
		// electionnewsworthiness
		{
			labelName: "election-newsworthiness",
			label: "How <strong>newsworthy</strong> do you think the <strong>U.S. Midterm Elections</strong> (and surrounding issues) are?",
			options: [
				{
					type: "radio",
					value: "1_no-newsworthiness", // value/response to send to server
					option: "No newsworthiness", // what to display
				},
				{
					type: "radio",
					value: "2_very-low-newsworthiness",
					option: "Very low newsworthiness",
				},
				{
					type: "radio",
					value: "3_low-newsworthiness",
					option: "Low newsworthiness",
				},
				{
					type: "radio",
					value: "4_some-newsworthiness",
					option: "Some newsworthiness",
				},
				{
					type: "radio",
					value: "5_high-newsworthiness",
					option: "High newsworthiness",
				},
				{
					type: "radio",
					value: "6_very-high-newsworthiness",
					option: "Very high newsworthiness",
				},
			],
		},
	];


	let covidfields = [
		// covidimportance
		{
			labelName: "covid-importance",
			label: "How <strong>important</strong> do you think <strong>COVID-19</strong> (and surrounding issues) is?",
			options: [
				{
					type: "radio",
					value: "1_no-importance", // value/response to send to server
					option: "No importance", // what to display
				},
				{
					type: "radio",
					value: "2_very-low-importance",
					option: "Very low importance",
				},
				{
					type: "radio",
					value: "3_low-importance",
					option: "Low importance",
				},
				{
					type: "radio",
					value: "4_some-importance",
					option: "Some importance",
				},
				{
					type: "radio",
					value: "5_high-importance",
					option: "High importance",
				},
				{
					type: "radio",
					value: "6_very-high-importance",
					option: "Very high importance",
				},
			],
		},
		// covidnewsworthiness
		{
			labelName: "covid-newsworthiness",
			label: "How <strong>newsworthy</strong> do you think <strong>COVID-19</strong> (and surrounding issues) is?",
			options: [
				{
					type: "radio",
					value: "1_no-newsworthiness", // value/response to send to server
					option: "No newsworthiness", // what to display
				},
				{
					type: "radio",
					value: "2_very-low-newsworthiness",
					option: "Very low newsworthiness",
				},
				{
					type: "radio",
					value: "3_low-newsworthiness",
					option: "Low newsworthiness",
				},
				{
					type: "radio",
					value: "4_some-newsworthiness",
					option: "Some newsworthiness",
				},
				{
					type: "radio",
					value: "5_high-newsworthiness",
					option: "High newsworthiness",
				},
				{
					type: "radio",
					value: "6_very-high-newsworthiness",
					option: "Very high newsworthiness",
				},
			],
		},
	];


	function shuffle(array) {
		let currentIndex = array.length,  randomIndex;

		// While there remain elements to shuffle.
		while (currentIndex != 0) {

			// Pick a remaining element.
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex--;

			// And swap it with the current element.
			[array[currentIndex], array[randomIndex]] = [
			array[randomIndex], array[currentIndex]];
		}

		return array;
	}

	let fields = [];
	// initial order
	let arr = ['M', 'J', 'E', 'C'];
	let xs = shuffle(arr);
	for (let i = 0; i < xs.length; i++) { 
		if (xs[i] == 'M') {
			fields = [...fields, ...monkeypoxfields];
			}
		else if (xs[i] == 'J') {
			fields = [...fields, ...johnnyfields];
			}
		else if (xs[i] == 'E') {
			fields = [...fields, ...electionfields];
			}
		else if (xs[i] == 'C') {
			fields = [...fields, ...covidfields];
			}
		}

	console.log("order", fields);

	// reverse options (high to low)
	fields.forEach((field) => {
		field.options.reverse();
	});

	// fields = fields.slice(fields.length - 2, fields.length);
</script>

<Navbar />

<section>
	<h1>News evaluation</h1>
	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{@html field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={[required]}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
			</div>
			{#if fi % 2 != 0 && fi != 7}
				<hr />
				<br />
			{/if}
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Next</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}

	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1597px) {
		.option-group {
			display: block;
		}
	}
</style>
